
import {createAsyncThunk} from '@reduxjs/toolkit'
import {getCustomerType} from 'sr/utils/api/masterData/customerType/getCustomerType'
export const fetchcustomerType = createAsyncThunk(
  'getCustomerType',
  async () => {
    const response = await getCustomerType()
    return response?.data
  }
)


